import { useState } from 'react';

const EditRoomModal = ({ room, onClose, onSave, onDelete }) => {
  const [name, setName] = useState(room.room_name);
  const [location, setLocation] = useState(room.location);
  const [comment, setComment] = useState(room.comment || '');

  const handleSave = () => {
    onSave({ ...room, room_name: name, location, comment });
    onClose();
  };

  const handleDelete = () => {
    if (window.confirm("Na pewno chcesz usunąć tę salę?")) {
      onDelete(room.room_id);
      onClose();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Edytuj salę</h3>
        <input className='form-input' value={name} onChange={e => setName(e.target.value)} placeholder="Nazwa sali" />
        <input className='form-input' value={location} onChange={e => setLocation(e.target.value)} placeholder="Lokalizacja" />
        <textarea className='form-input' value={comment} onChange={e => setComment(e.target.value)} placeholder="Komentarz" />

        <div className="modal-actions">
          <button onClick={handleSave} className="button button-primary">Zapisz</button>
          <button onClick={handleDelete} className="button button-danger">Usuń</button>
          <button onClick={onClose} className="button-secondary">Anuluj</button>
        </div>
      </div>
    </div>
  );
};

export default EditRoomModal;